import smartSuggestionsPluginTrigger from './utils/smartSuggestionsPluginTrigger';
import createLazyPlugin from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "SmartSuggestions" */ './plugin/SmartSuggestionsPlugin');
});
export var LazySmartSuggestionsPluginClass = createLazyPlugin(lazyModule, function (m) { return m.default; }, 'SmartSuggestion', smartSuggestionsPluginTrigger);
//# sourceMappingURL=index.js.map